import { render, staticRenderFns } from "./StatsCards.vue?vue&type=template&id=6dc5db84&"
import script from "./StatsCards.vue?vue&type=script&lang=js&"
export * from "./StatsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports